import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Icons
const DashboardIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path>
  </svg>
);

const ProjectsIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
  </svg>
);

const AnalyticsIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
  </svg>
);

const HelpIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
  </svg>
);

const ToolsIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
  </svg>
);

const ProfileIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
  </svg>
);

const ImageOptimizerIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
  </svg>
);

const YoutubeDownloaderIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0C.488 3.45.029 5.804 0 12c.029 6.185.484 8.549 4.385 8.816 3.599.245 11.626.246 15.23 0C23.512 20.55 23.971 18.196 24 12c-.029-6.185-.484-8.549-4.385-8.816zM9 16V8l8 3.993L9 16z"/>
  </svg>
);

const SeoMassGeneratorIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
);

const AurelioBuilderIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
  </svg>
);

const navigationItems = [
  { name: "Dashboard", icon: <DashboardIcon />, href: "/dashboard" },
  { 
    name: "Herramientas", 
    icon: <ToolsIcon />, 
    href: "/dashboard/tools",
    subitems: [
      { name: "Aurelio Builder", icon: <AurelioBuilderIcon />, href: "/dashboard/tools/aurelio-builder" },
      { name: "Optimizador de Imágenes", icon: <ImageOptimizerIcon />, href: "/dashboard/tools/image-optimizer" },
      { name: "YouTube Downloader", icon: <YoutubeDownloaderIcon />, href: "/dashboard/tools/youtube-downloader" },
      { name: "SEO Mass", icon: <SeoMassGeneratorIcon />, href: "/dashboard/tools/seo-mass-generator" }
    ]
  },
  { name: "Proyectos", icon: <ProjectsIcon />, href: "/projects" },
  { name: "Análisis", icon: <AnalyticsIcon />, href: "/analytics" },
  { name: "Configuración", icon: <SettingsIcon />, href: "/settings" },
  { name: "Ayuda", icon: <HelpIcon />, href: "/help" },
];
function Sidebar({ isOpen, toggleSidebar }) {
  const location = useLocation();
  const { user } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleExpand = (itemName) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemName]: !prev[itemName]
    }));
  };

  const sidebarClasses = isCollapsed ? "w-20" : "w-64";
  const mobileClasses = isOpen ? "translate-x-0" : "-translate-x-full";

  return (
    <>
      {/* Desktop Sidebar */}
      <div className={`hidden md:flex h-full flex-col bg-[#121212] border-r border-[#2a2a2a] transition-all duration-300 ${sidebarClasses}`}>
        <div className="flex items-center h-16 px-4 border-b border-[#2a2a2a]">
          <Link to="/dashboard" className="flex items-center">
            <div className="flex-shrink-0 w-8 h-8">
              <img 
                src="/wemax-logo.png" 
                alt="Wemax Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            {!isCollapsed && <span className="ml-2 text-xl font-bold text-white">WeMax</span>}
          </Link>
          <button
            onClick={toggleCollapse}
            className="ml-auto text-gray-400 hover:text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isCollapsed ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 5l7 7-7 7M5 5l7 7-7 7"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
                />
              )}
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-4">
          <nav className="space-y-1 px-2">
            {navigationItems.map((item) => {
              const isActive = location.pathname === item.href || 
                              (item.subitems && item.subitems.some(subitem => location.pathname === subitem.href));
              const isExpanded = expandedItems[item.name] || isActive;

              return (
                <div key={item.name}>
                  {item.subitems ? (
                    <div>
                      <button
                        onClick={() => toggleExpand(item.name)}
                        className={`w-full group flex items-center px-2 py-3 text-sm font-medium rounded-md transition-all duration-200 ${
                          isActive
                            ? "bg-[#1e1e1e] text-[#ff1b6d]"
                            : "text-gray-300 hover:bg-[#1e1e1e] hover:text-white"
                        }`}
                      >
                        <div className={`${isActive ? "text-[#ff1b6d]" : "text-gray-400 group-hover:text-white"} mr-3`}>
                          {item.icon}
                        </div>
                        {!isCollapsed && <span>{item.name}</span>}
                        {!isCollapsed && (
                          <svg 
                            className={`ml-auto h-4 w-4 transform transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`} 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                        )}
                      </button>

                      {isExpanded && !isCollapsed && (
                        <div className="mt-1 space-y-1 pl-10">
                          {item.subitems.map(subitem => {
                            const isSubActive = location.pathname === subitem.href;
                            return (
                              <Link
                                key={subitem.name}
                                to={subitem.href}
                                className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
                                  isSubActive
                                    ? "text-[#ff1b6d]"
                                    : "text-gray-300 hover:text-white"
                                }`}
                              >
                                <div className={`${isSubActive ? "text-[#ff1b6d]" : "text-gray-400 group-hover:text-white"} mr-3`}>
                                  {subitem.icon}
                                </div>
                                <span>{subitem.name}</span>
                                {isSubActive && (
                                  <span className="ml-auto bg-[#ff1b6d] rounded-full w-1.5 h-1.5"></span>
                                )}
                              </Link>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      className={`group flex items-center px-2 py-3 text-sm font-medium rounded-md transition-all duration-200 ${
                        isActive
                          ? "bg-[#1e1e1e] text-[#ff1b6d]"
                          : "text-gray-300 hover:bg-[#1e1e1e] hover:text-white"
                      }`}
                    >
                      <div className={`${isActive ? "text-[#ff1b6d]" : "text-gray-400 group-hover:text-white"} mr-3`}>
                        {item.icon}
                      </div>
                      {!isCollapsed && <span>{item.name}</span>}
                      {isActive && !isCollapsed && (
                        <span className="ml-auto bg-[#ff1b6d] rounded-full w-1.5 h-1.5"></span>
                      )}
                    </Link>
                  )}
                </div>
              );
            })}
          </nav>
        </div>

        <div className="flex-shrink-0 p-4 border-t border-[#2a2a2a]">
          <Link
            to="/dashboard/profile"
            className="group block w-full"
          >
            <div className="flex items-center">
              <div>
                <img
                  className="inline-block h-9 w-9 rounded-full object-cover"
                  src={user?.photoURL}
                  alt="Profile"
                />
              </div>
              {!isCollapsed && (
                <div className="ml-3">
                  <p className="text-sm font-medium text-white">{user?.displayName || user?.name || "Usuario Wemax"}</p>
                  <p className="text-xs font-medium text-gray-400 group-hover:text-gray-300">
                    Ver perfil
                  </p>
                </div>
              )}
            </div>
          </Link>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`md:hidden fixed inset-0 flex z-40 ${isOpen ? "visible" : "invisible"}`}>
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" onClick={toggleSidebar}></div>
        <div className={`relative flex-1 flex flex-col max-w-xs w-full bg-[#121212] transform transition ease-in-out duration-300 ${mobileClasses}`}>
          <div className="absolute top-0 right-0 -mr-12 pt-2">
            <button
              type="button"
              className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              onClick={toggleSidebar}
            >
              <span className="sr-only">Close sidebar</span>
              <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
            <div className="flex-shrink-0 flex items-center px-4">
              <div className="w-8 h-8">
                <img 
                  className="w-full h-full object-contain" 
                  src="/wemax-logo.png" 
                  alt="Wemax Logo" 
                />
              </div>
              <span className="ml-2 text-xl font-bold text-white">WeMax</span>
            </div>
            <nav className="mt-5 px-2 space-y-1">
              {navigationItems.map((item) => {
                const isActive = location.pathname === item.href || 
                                (item.subitems && item.subitems.some(subitem => location.pathname === subitem.href));
                const isExpanded = expandedItems[item.name] || isActive;

                return (
                  <div key={item.name}>
                    {item.subitems ? (
                      <div>
                        <button
                          onClick={() => toggleExpand(item.name)}
                          className={`w-full group flex items-center px-2 py-3 text-base font-medium rounded-md ${
                            isActive
                              ? "bg-[#1e1e1e] text-[#ff1b6d]"
                              : "text-gray-300 hover:bg-[#1e1e1e] hover:text-white"
                          }`}
                        >
                          <div className={`${isActive ? "text-[#ff1b6d]" : "text-gray-400 group-hover:text-white"} mr-4`}>
                            {item.icon}
                          </div>
                          {item.name}
                          <svg 
                            className={`ml-auto h-4 w-4 transform transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`} 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                        </button>

                        {isExpanded && (
                          <div className="mt-1 space-y-1 pl-10">
                            {item.subitems.map(subitem => {
                              const isSubActive = location.pathname === subitem.href;
                              return (
                                <Link
                                  key={subitem.name}
                                  to={subitem.href}
                                  className={`group flex items-center px-2 py-2 text-base font-medium rounded-md transition-all duration-200 ${
                                    isSubActive
                                      ? "text-[#ff1b6d]"
                                      : "text-gray-300 hover:text-white"
                                  }`}
                                >
                                  <div className={`${isSubActive ? "text-[#ff1b6d]" : "text-gray-400 group-hover:text-white"} mr-3`}>
                                    {subitem.icon}
                                  </div>
                                  <span>{subitem.name}</span>
                                  {isSubActive && (
                                    <span className="ml-auto bg-[#ff1b6d] rounded-full w-1.5 h-1.5"></span>
                                  )}
                                </Link>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ) : (
                      <Link
                        to={item.href}
                        className={`group flex items-center px-2 py-3 text-base font-medium rounded-md ${
                          isActive
                            ? "bg-[#1e1e1e] text-[#ff1b6d]"
                            : "text-gray-300 hover:bg-[#1e1e1e] hover:text-white"
                        }`}
                      >
                        <div className={`${isActive ? "text-[#ff1b6d]" : "text-gray-400 group-hover:text-white"} mr-4`}>
                          {item.icon}
                        </div>
                        {item.name}
                        {isActive && (
                          <span className="ml-auto bg-[#ff1b6d] rounded-full w-1.5 h-1.5"></span>
                        )}
                      </Link>
                    )}
                  </div>
                );
              })}
            </nav>
          </div>
          <div className="flex-shrink-0 flex border-t border-[#2a2a2a] p-4">
            <Link to="/dashboard/profile" className="flex-shrink-0 group block">
              <div className="flex items-center">
                <div>
                  <img
                    className="inline-block h-10 w-10 rounded-full object-cover"
                    src={user?.photoURL}
                    alt="Profile"
                  />
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-white">{user?.displayName || user?.name || "Usuario Wemax"}</p>
                  <p className="text-xs font-medium text-gray-400 group-hover:text-gray-300">
                    Ver perfil
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
